import React from 'react';

import ModelView from '../../../ModelView';
import StepNavigator from '../StepNavigator';

const ModelStep = ({ onNext, onBack, wizardType }) => (
  <>
    <div className="wizard-step-top">
      <div className="wizard-step-top__header">
        <h1>{'Upload 3D & 2D models'}</h1>
      </div>
    </div>
    <div
      className={`wizard-step-main__body--framed custom-thin-scrollbar model-step ${wizardType}`}
    >
      <ModelView
        wizardType={wizardType}
        withMappingButtons
      />
    </div>
    <StepNavigator
      onBack={onBack}
      onNext={onNext}
    />
  </>
);

export default ModelStep;
